import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

/**
 * IconLabelComponent
 *
 * Displays an icon with an accompanying text label.
 * Used for displaying location/activity information like "Multihallen / Bane1"
 *
 * Accessibility:
 * - Icon is hidden from screen readers (decorative)
 * - Component uses role='img' with aria-label for semantic meaning
 * - Full text content is announced to assistive technologies
 *
 * Inputs:
 * - icon: Material icon name
 * - text: Label text to display (used as aria-label)
 *
 * Example:
 * <app-icon-label icon="location_on" text="Multihallen / Bane 1" />
 */
@Component({
  selector: 'app-icon-label',
  imports: [MatIconModule, NgClass],
  templateUrl: './icon-label.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './icon-label.component.scss',
})
export class IconLabelComponent {
  /*
   * size options: 'small' | 'medium'
   */
  size = input<'small' | 'medium'>('small');

  /**
   * Material icon name
   */
  icon = input<string>('');

  /**
   * Label text to display alongside the icon
   */
  text = input<string>('');
}
